import { Box, Button, Dialog, DialogContent, DialogTitle, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, InputLabel, makeStyles, MenuItem, Paper, Radio, Select, Tab, Tabs } from "@material-ui/core";
import Typography from '@material-ui/core/Typography';
import BlockIcon from '@material-ui/icons/Block';
import CheckIcon from '@material-ui/icons/Check';
import PrintIcon from '@material-ui/icons/Print';
import { DatePicker } from "@material-ui/pickers";
import clsx from 'clsx';
import withLayout from "components/HoC/withLayout";
import { UploadButton } from "components/request-document/components/Commons";
import { format } from "date-fns";
import { useFormik } from "formik";
import { STATUS_PROCESS, VISA_TYPE_NAME } from "libs/configs/constant";
import useAdminModalLoading from "libs/hooks/useAdminModalLoading";
import useModalLoading from "libs/hooks/useModalLoading";
import { openFileById } from "libs/utils/file";
import { getErrorMessage } from "libs/utils/form";
import { get, isError } from "lodash";
import mime from 'mime';
import PropTypes from 'prop-types';
import queryString from "query-string";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import { getBranchList } from "redux/modules/branchSlice";
import { getMasterData, selectMasterData } from "redux/modules/masterSlice";
import AllDocumentsService from "services/AllDocumentsService";
import AppointmentService from "services/AppointmentService";
import FileService from "services/FileService";
import * as yup from 'yup';
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    padding: 0,
    paddingBottom: 124,
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    padding: theme.spacing(4),
    borderRadius: 16,
  },
  userName: {
    fontSize: "1.25rem", fontWeight: "600", fontFamily: "system-ui", color: "#4A5C6A"
  },
  wrapDocDetail: {
    marginTop: 30
  },
  appTitle: {
    color: 'rgba(0,0,0,0.54)',
    fontSize: "13px",
    marginTop: 30,
  },
  appValue: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 15
  },
  appValue1: {
    color: "#8898AA", fontWeight: "500", fontSize: "15px"
  },
  appValue2: {
    color: "#2196F3", fontSize: "18px", fontFamily: "system-ui", fontWeight: "500", paddingTop: "10px"
  },
  appValue3: {
    alignItems: "center", display: "flex"
  },
  tabAppointment: {
    marginTop: "36px", fontSize: "14px", borderBottom: "1px solid whitesmoke", paddingBottom: "8px"
  },
  flexMiddle: {
    display: 'flex',
    alignItems: 'center'
  },
  appointmentText: {
    color: "#003668", fontSize: "14px", display: "inline-block", fontWeight: "400", marginRight: "15px"
  },
  appointmentDate: {
    backgroundColor: "#E3F2FD", padding: "7px 10px", display: "inline-block", color: "#2196F3", fontWeight: "bold", fontSize: "14px"
  },
  appointmentDate2: {
    backgroundColor: "#11CDEF", padding: "7px 10px", display: "inline-block", color: "white", fontWeight: "500", fontSize: "14px"
  },
  wrapAppointmentDate: {
    display: 'flex',
    alignItems: 'center'
  },
  wrapContoller: {
    marginTop: 30,
  },
  textDialog: {
    width: "100%",
  },
  rowInput: {
    marginTop: 10,
  },
  warpButtonDialogSave: {
    display: "flex",
  },
  buttonDialogSave: {
    width: "100%",
    margin: "15px 5px",
  },
  sigImage: {
    backgroundSize: "200px 50px", height: "200px", width: "100%", backgroundColor: "white", borderRadius: 15
  },
  middle: {
    display: "flex", alignItems: "center", justifyContent: "center"
  },
  wrapNoFile: { position: "absolute", width: "100%", height: "100%", top: "0", left: "0", zIndex: "11", backgroundColor: "rgba(237, 28, 36, 0.2)", border: "2px solid #ED1C24" },
  nofile: { backgroundColor: "rgba(237, 28, 36, 0.2)", border: "2px solid #ED1C24" },
  requiredDoc: {
    textAlign: "center", color: "#ED1C24", fontSize: "13px", fontWeight: "500", marginTop: "10px"
  }
}));


function AppointmentTab() {
  const classes = useStyles();
  const [appDate, setAppDate] = useState(new Date());
  const [stampDetail, setStampDetail] = useState(null);
  const [docDetail, setDocDetail] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [open, setOpen] = React.useState(false);

  const [brachFilter, setBrachFilter] = React.useState([]);
  const [signDataUri, setSignDataUri] = useState(null);
  const [imageDataUri, setImageDataUri] = useState('');
  const params = useParams();
  const { showLoading, hideLoading } = useModalLoading();
  const { showAdminLoading, hideAdminLoading } = useAdminModalLoading();
  const draftId = get(params, "draftId", "") || "";

  const { search } = useLocation();
  const queryParams = queryString.parse(search);

  const [value, setValue] = React.useState(queryParams?.stamped === '1' ? 1 : 0);

  const { list: branchList } = useSelector((state) => state.branch);


  const [openDocUpload, setOpenDocUpload] = React.useState(false);
  const masterData = useSelector(selectMasterData);
  const validationSchema = yup.object({
    // empId: yup.string().required("Employee is required.")
    // startDate: yup.date().required("Date is required."),
    // remark: yup.string().required("Holiday name is required."),
  });


  const dispatch = useDispatch();
  const countryConfig = get(masterData, "countryConfig", []);
  const theImmigrationBureauConfig = get(
    masterData,
    "theImmigrationBureauConfig",
    []
  );


  useEffect(() => {
    const braches = [].concat.apply([], branchList.filter(c =>
      c.countryId === formik.values.countryId
    ).map(x => x.branchs))

    setBrachFilter(braches);
  }, [branchList]);


  useEffect(() => {

    async function mergedFetchData() {
      showAdminLoading();
      await dispatch(
        getMasterData({
          CountryConfig: true,
          theImmigrationBureauConfig: true,
        })
      );

      await dispatch(getBranchList({
        isThailand: true,
        allStatus: true
      }));

      // await fetchData();
      hideAdminLoading();
    }
    mergedFetchData();


  }, [dispatch]);




  // useEffect(() => {


  //   formik.setFieldValue('overseas', isOversea)
  //   formik.setFieldValue('thailand', !isOversea)
  //   formik.setFieldValue('countryId', docDetail?.visaissurance?.countryId)
  //   formik.setFieldValue('brachID', docDetail?.visaissurance?.branchID)
  //   console.log(branchList);
  //   console.log(formik.values.countryId);
  // }, [branchList]);





  useEffect(async () => {
    await getAppointment();

    if (queryParams?.stamped === '1' && stampDetail?.stampStatus == 'C' && !stampDetail?.stampFileId) {
      setOpenDocUpload(true);
    }


  }, [])


  useEffect(async () => {
    if (stampDetail) {
      if (queryParams?.stamped === '1' && stampDetail?.stampStatus == 'C' && !stampDetail?.stampFileId) {
        setOpenDocUpload(true);
      }
    }
  }, [stampDetail])

  const getAppointment = async () => {
    const resDoc = await AllDocumentsService.getAllDocuments({ draftId: draftId });
    if (resDoc.status && resDoc.results?.length > 0) {
      const _docDetail = resDoc.results[0];
      setDocDetail(_docDetail)

      const _isOversea = _docDetail?.visaissurance?.overseas;
      formik.setFieldValue('overseas', _isOversea)
      formik.setFieldValue('thailand', !_isOversea)
      formik.setFieldValue('countryId', _docDetail?.visaissurance?.countryId)
      formik.setFieldValue('branchID', _docDetail?.visaissurance?.branchID)
    }
    const res = await AppointmentService.getAppointments({ draftId: draftId });
    if (res.status && res.results?.length > 0) {
      const detail = res.results[0];
      setStampDetail(detail);
      setEditMode(false);



      if (detail.userProfileFileId) {
        const data = await FileService.getFile(detail.userProfileFileId);
        try {
          const fileName = detail.userProfileFileName + detail.userProfileFileExt;
          const blobFile = new File([data], fileName, {
            type: mime.getType(detail.userProfileFileExt),
          });


          setImageDataUri(URL.createObjectURL(blobFile))
        } catch (error) {
          console.error(error);
        }
      }
      if (detail.userSignedFileId) {
        const data = await FileService.getFile(detail.userSignedFileId);
        try {
          const fileName = detail.userSignedFileName + detail.userSignedFileExt;
          const blobFile = new File([data], fileName, {
            type: mime.getType(detail.userSignedFileExt),
          });

          setSignDataUri(URL.createObjectURL(blobFile))
        } catch (error) {
          console.error(error);
        }
      }
    }
    else {
      setStampDetail(null);
      setEditMode(true);
    }
  }


  const isOversea = docDetail?.visaissurance?.overseas;

  let formik = useFormik({
    enableReinitialize: true,
    validationSchema,
    initialValues: {
      overseas: isOversea || '',
      thailand: !isOversea || '',
      countryId: docDetail?.visaissurance?.countryId || '',
      branchID: docDetail?.visaissurance?.branchID || ''
    },
    onSubmit: async (c) => {
      console.log(c);
    },
  });

  const handleOnStampDate = async () => {

    if (!window.confirm("Do you want to stamp this date?")) { return }
    showLoading();



    try {
      const body = {
        draftId: draftId,
        stampDate: format(new Date(appDate), "yyyy-MM-dd"),
        status: true,
        overseas: (formik.values.overseas) ? formik.values.overseas : false,
        countryId: formik.values.countryId,
        branchID: formik.values.branchID,
        thailand: (formik.values.thailand) ? formik.values.thailand : false,
        visaInssuanceId: docDetail?.visaissurance?.visaInssuanceId
      };
      const res = await AppointmentService.stampAppointment(body);
      if (res.status) {
        await getAppointment();

      }
    } catch (error) {
      console.error(error);
      alert('Something wrong!')
    }


    hideLoading();

  }
  const handleClose = async (value) => {
    setOpen(false);
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  console.log(brachFilter);
  return (
    <Paper className={classes.paper}>
      <div className={classes.root}>
        <ChangeUserPass open={open} onClose={handleClose} />
        <DocumentUpload open={openDocUpload} onClose={() => {
          setOpenDocUpload(false);
        }} />
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange}>
            <Tab label="นัดหมายประทับตรา" />
            {
              stampDetail?.stampStatus == 'C' &&

              <Tab label="ยื่นหนังสืออนุมัติ" />

            }
          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <div className={classes.wrapDocDetail} style={{ borderBottom: "1px solid lightgray", paddingBottom: "40px" }}>
            {/* <div className={classes.appTitle}>
          ข้อมูลการยื่นคำขอ
        </div> */}


            <Grid container spacing={3}>
              <Grid item xs={12} md={8}>
                <div className={classes.appValue}>


                  <div className={classes.appValue1} style={{ marginRight: "15px" }}>
                    วันที่นัดหมาย
                  </div>
                  <div className={classes.appValue3}>

                    {
                      !editMode &&
                      <>
                        <div className={classes.appointmentDate} style={{ color: "#2DCE98", backgroundColor: "transparent", border: "1px solid #2DCE98" }}>
                          <div className={classes.wrapAppointmentDate}>
                            <CheckIcon style={{ marginRight: 10 }} />
                            <span >
                              {stampDetail?.stampDate && format(new Date(stampDetail?.stampDate), "yyyy-MM-dd")}
                            </span>
                          </div>


                        </div>

                        {
                          stampDetail?.stampStatus == 'P' &&
                          <>
                            <Button
                              style={{ marginLeft: 30 }}
                              variant="contained"
                              color="primary"
                              size="small"
                              onClick={() => {
                                setEditMode(true)
                              }}
                            >
                              แก้ไข
                            </Button>
                            <Button
                              style={{ marginLeft: 5 }}
                              variant="outlined"
                              color="primary"
                              size="small"
                              onClick={async () => {
                                if (!window.confirm("Do you want to cancel appointment?")) { return }

                                const body = {
                                  draftId: draftId,
                                  stampDate: format(new Date(appDate), "yyyy-MM-dd"),
                                  status: false
                                };
                                const res = await AppointmentService.stampAppointment(body);
                                if (res.status) {
                                  await getAppointment();

                                }

                              }}
                            >
                              ยกเลิก
                            </Button>
                          </>
                        }

                      </>
                    }
                    {
                      editMode &&
                      <>
                        <DatePicker
                          style={{ width: 200, marginRight: 15 }}
                          className={classes.formControl}
                          inputVariant="outlined"
                          openTo="year"
                          format="DD-MM-YYYY"
                          label="Appointment Date"
                          views={["year", "month", "date"]}
                          name={`appointmentDate`}
                          value={appDate}
                          onChange={(e) => {
                            setAppDate(e)
                          }}
                        />
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={handleOnStampDate}
                        >
                          ยืนยันวันนัดประทับตรา
                        </Button>
                      </>
                    }

                  </div>
                </div>
              </Grid>
              <Grid item xs={12} md={4} style={{ alignItems: "center", display: "flex", justifyContent: "end" }}>
                <div style={{ textAlign: 'right' }} >
                  <div style={{ color: "#5F5F5F", fontWeight: "500", fontSize: "16px" }}>
                    เลขที่เอกสาร
                  </div>


                  <div style={{ color: "#1094D8", fontWeight: "500", marginTop: "5px", fontSize: "20px" }}>
                    {docDetail?.smartNo}
                  </div>
                </div>

              </Grid>
            </Grid>
          </div>

          {
            branchList.length > 0 &&
            <div className={classes.wrapDocDetail} style={{ borderBottom: "1px solid lightgray", paddingBottom: "40px" }}>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <div style={{ color: "rgb(23, 43, 77)", fontWeight: "bold", fontSize: "16px" }}>
                    สถานที่ประทับตรา
                  </div>
                </Grid>

                <Grid item xs={12} md={6}>
                  <FormGroup row style={{ display: 'block' }}>
                    <FormControlLabel
                      control={
                        <Radio
                          disabled={!editMode}
                          name="overseas"
                          value={formik.values.overseas}
                          checked={Boolean(formik.values.overseas)}
                          onClick={() => {
                            formik.setFieldValue("overseas", true);
                            formik.setFieldValue("thailand", false);
                            formik.setFieldValue("countryId", null);
                            formik.setFieldValue("branchID", null);
                          }}
                        />
                      }
                      label="Overseas; Thai Embassy or Consulate in"
                    />
                    <FormControlLabel
                      control={
                        <Radio
                          disabled={!editMode}
                          name="thailand"
                          value={formik.values.thailand}
                          checked={Boolean(formik.values.thailand)}
                          onClick={() => {
                            formik.setFieldValue("thailand", true);
                            formik.setFieldValue("overseas", false);
                            formik.setFieldValue("countryId", null);
                            formik.setFieldValue("branchID", null);
                          }}
                        />
                      }
                      label="Thailand"
                    />


                    <div className={classes.flexRow} style={{ marginTop: 15 }}>
                      <FormControl
                        disabled={!editMode}
                        variant="outlined"
                        className={classes.formControl}
                        error={isError("countryId", formik)}
                      >
                        <InputLabel>Country</InputLabel>
                        <Select
                          disabled={!editMode}
                          style={{ marginRight: 10, width: 200 }}
                          label="Country"
                          name="countryId"
                          value={formik.values.countryId}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {branchList
                            .filter(
                              (country) =>
                                // (formik.values.overseas && country.countryName !== 'Thailand') ||
                                (formik.values.overseas) ||
                                (formik.values.thailand && country.countryName === 'Thailand')
                            )
                            .map((country) => (
                              <MenuItem
                                value={country.countryId}
                                key={country.countryId}
                              >
                                {country.countryName}
                              </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText
                          error={isError("countryId", formik)}
                        >
                          {getErrorMessage("countryId", formik)}
                        </FormHelperText>

                      </FormControl>



                      <FormControl
                        variant="outlined"
                        className={classes.formControl}
                        error={isError("branchID", formik)}
                        disabled={!editMode}
                      >
                        <InputLabel>Branch</InputLabel>
                        <Select
                          disabled={!editMode}
                          style={{ marginRight: 10, width: 200 }}
                          label="Branch"
                          name="branchID"
                          value={formik.values.branchID}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                        >
                          {
                            // brachFilter
                            [].concat.apply([], branchList.filter(c =>
                              c.countryId === formik.values.countryId
                            ).map(x => x.branchs))
                              .map((country) => (
                                <MenuItem
                                  value={country.branchID}
                                  key={country.branchID}>
                                  {country.branchName}
                                </MenuItem>
                              ))}


                          {/* {get(
                branchList.find(
                  (country) =>
                    country.countryId ===
                    formik.values.countryId
                ),
                "branchs",
                []
              ).map((country) => (
                <MenuItem
                  value={country.branchID}
                  key={country.branchID}
                >
                  {country.branchName}
                </MenuItem>
              ))} */}
                        </Select>
                        <FormHelperText
                          error={isError("branchID", formik)}
                        >
                          {getErrorMessage("branchID", formik)}
                        </FormHelperText>
                      </FormControl>
                    </div>
                  </FormGroup>
                </Grid>

              </Grid>



            </div>
          }




          <div className={classes.wrapDocDetail} style={{ borderBottom: "1px solid lightgray", paddingBottom: "40px" }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div style={{ color: "rgb(23, 43, 77)", fontWeight: "bold", fontSize: "16px" }}>
                  ข้อมูลผู้ยื่น
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>
                  ชื่อ-สกุล
                </div>
                <div className={classes.appValue2}>
                  {docDetail?.firstname}    {docDetail?.lastname}
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>
                  หนังสือเดินทางเลขที่
                </div>
                <div className={classes.appValue2}>
                  {docDetail?.passport}
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>
                  ประเภท VISA
                </div>
                <div className={classes.appValue2}>
                  {VISA_TYPE_NAME[docDetail?.smartserviceId]}
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>
                  วันที่ยื่น
                </div>
                <div className={classes.appValue2}>

                  {docDetail?.smartDate && format(new Date(docDetail?.smartDate), "yyyy-MM-dd")}
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>
                  วันที่อนุมัติ
                </div>
                <div className={classes.appValue2} style={{ color: '#2DCE98' }}>
                  {stampDetail?.approvedDate ? format(new Date(stampDetail?.approvedDate), "yyyy-MM-dd") : '-'}

                </div>
              </Grid>
            </Grid>
          </div>

          <div className={classes.wrapDocDetail} style={{ borderBottom: "1px solid lightgray", paddingBottom: "40px" }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div style={{ color: "rgb(23, 43, 77)", fontWeight: "bold", fontSize: "16px" }}>
                  เจ้าหน้าที่ที่รับผิดชอบ
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>
                  ชื่อ-สกุล
                </div>
                <div className={classes.appValue2}>
                  {docDetail?.staffname}
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>
                  เบอร์โทรศัพท์
                </div>
                <div className={classes.appValue2}>
                  {docDetail?.phone}
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>
                  อีเมล
                </div>
                <div className={classes.appValue2}>
                  {docDetail?.staffemail}
                </div>

              </Grid>
            </Grid>
          </div>

          <div className={classes.wrapDocDetail} style={{ borderBottom: "1px solid lightgray", paddingBottom: "40px" }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <div style={{ color: "rgb(23, 43, 77)", fontWeight: "bold", fontSize: "16px" }}>
                  เจ้าหน้าที่ตม.
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>
                  ชื่อ-สกุล
                </div>
                <div className={classes.appValue2}>
                  {stampDetail?.empAssignedFirstName}       {stampDetail?.empAssignedLastName}
                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>
                  เบอร์โทรศัพท์
                </div>
                <div className={classes.appValue2}>

                </div>
              </Grid>
              <Grid item xs={12} md={4}>
                <div className={classes.appValue1}>
                  อีเมล
                </div>
                <div className={classes.appValue2}>
                  {stampDetail?.empAssignedEmail}
                </div>

              </Grid>
            </Grid>
          </div>
          {
            stampDetail &&
            <div className={classes.wrapDocDetail} style={{ borderBottom: "1px solid lightgray", textAlign: 'center', paddingBottom: "40px" }}>


              <div className={classes.appointmentDate2}
                onClick={async () => {
                  const body = {
                    draftId: stampDetail?.draftId
                  };
                  const blob = await AppointmentService.getReportAppoint(body)

                  const blobFile = new File([blob], 'Appointment.pdf', {
                    type: mime.getType('.pdf'),
                  });

                  window.open(
                    URL.createObjectURL(blobFile, 'Appointment.pdf'),
                    "_blank"
                  );
                }}
                style={{ marginRight: 15, cursor: 'pointer' }}>
                <div className={classes.wrapAppointmentDate}>
                  <PrintIcon style={{ marginRight: 10 }} />
                  <span>
                    พิมพ์ใบนัด
                  </span>
                </div>


              </div>

              <div className={classes.appointmentDate2} style={{ marginRight: 15, cursor: 'pointer' }}
                onClick={async () => {
                  const body = {
                    draftId: stampDetail?.draftId
                  };
                  const blob = await AppointmentService.getReportPayment(body)

                  const blobFile = new File([blob], 'payment.pdf', {
                    type: mime.getType('.pdf'),
                  });

                  window.open(
                    URL.createObjectURL(blobFile, 'payment.pdf'),
                    "_blank"
                  );
                }}
              >
                <div className={classes.wrapAppointmentDate}>
                  <PrintIcon style={{ marginRight: 10 }} />
                  <span>
                    พิมพ์ใบชำระเงิน
                  </span>
                </div>


              </div>


            </div>
          }
          {
            stampDetail?.stampStatus == 'C' &&
            <div className={classes.wrapDocDetail} style={{}}>

              <Grid container spacing={3}>


                <Grid item xs={12} md={4}>
                  <div style={{ color: "rgb(23, 43, 77)", fontWeight: "bold", fontSize: "16px", marginBottom: 15 }}>
                    รูปถ่าย
                  </div>
                  <div>
                    <img className={classes.sigImage}
                      src={imageDataUri} />
                  </div>
                </Grid>

                <Grid item xs={12} md={8}>
                  <div style={{ color: "rgb(23, 43, 77)", fontWeight: "bold", fontSize: "16px", marginBottom: 15 }}>
                    ลายเซ็นต์
                  </div>
                  <div>
                    <img className={classes.sigImage}
                      style={{ width: "100%", height: "170px", borderRadius: "15px", backgroundSize: "200px 50px", backgroundColor: "white" }}
                      src={signDataUri} />
                  </div>
                </Grid>
              </Grid>

            </div>
          }

        </TabPanel>

        {
          stampDetail?.stampStatus == 'C' &&

          <TabPanel value={value} index={1}>
            <div className={classes.wrapDocDetail} style={{ borderBottom: "1px solid lightgray", paddingBottom: "40px" }}>

              <Grid container spacing={3}>
                <Grid item xs={12} md={8}>
                  <div className={classes.appValue}>
                    <div className={classes.appValue1} style={{ marginRight: "15px" }}>
                      วันที่นัดหมาย
                    </div>
                    <div className={classes.appValue3}>
                      {
                        !editMode &&
                        <>
                          <div className={classes.appointmentDate} style={{ color: "#2DCE98", backgroundColor: "transparent", border: "1px solid #2DCE98" }}>
                            <div className={classes.wrapAppointmentDate}>
                              <CheckIcon style={{ marginRight: 10 }} />
                              <span >
                                {stampDetail?.stampDate && format(new Date(stampDetail?.stampDate), "yyyy-MM-dd")}
                              </span>
                            </div>
                          </div>
                          {
                            stampDetail?.stampStatus == 'P' &&
                            <>
                              <Button
                                style={{ marginLeft: 30 }}
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={() => {
                                  setEditMode(true)
                                }}
                              >
                                แก้ไข
                              </Button>
                              <Button
                                style={{ marginLeft: 5 }}
                                variant="outlined"
                                color="primary"
                                size="small"
                                onClick={async () => {
                                  if (!window.confirm("Do you want to cancel appointment?")) { return }

                                  const body = {
                                    draftId: draftId,
                                    stampDate: format(new Date(appDate), "yyyy-MM-dd"),
                                    status: false
                                  };
                                  const res = await AppointmentService.stampAppointment(body);
                                  if (res.status) {
                                    await getAppointment();
                                  }
                                }}
                              >
                                ยกเลิก
                              </Button>
                            </>
                          }

                        </>
                      }
                      {
                        editMode &&
                        <>
                          <DatePicker
                            style={{ width: 200, marginRight: 15 }}
                            className={classes.formControl}
                            inputVariant="outlined"
                            openTo="year"
                            format="DD-MM-YYYY"
                            label="Appointment Date"
                            views={["year", "month", "date"]}
                            name={`appointmentDate`}
                            value={appDate}
                            onChange={(e) => {
                              setAppDate(e)
                            }}
                          />
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleOnStampDate}
                          >
                            ยืนยันวันนัดประทับตรา
                          </Button>
                        </>
                      }

                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={4} style={{ alignItems: "center", display: "flex", justifyContent: "end" }}>
                  <div style={{ textAlign: 'right' }} >
                    <div style={{ color: "#5F5F5F", fontWeight: "500", fontSize: "16px" }}>
                      เลขที่เอกสาร
                    </div>


                    <div style={{ color: "#1094D8", fontWeight: "500", marginTop: "5px", fontSize: "20px" }}>
                      {docDetail?.smartNo}
                    </div>
                  </div>

                </Grid>

              </Grid>
            </div>
            <div className={classes.wrapDocDetail} style={{ borderBottom: "1px solid lightgray", paddingBottom: "40px" }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={4} style={{ borderRight: "1px solid lightgray" }}>
                  <div className={classes.middle} >

                    <div style={{ position: 'relative', padding: 15 }} className={clsx({
                      [classes.nofile]: stampDetail?.stampStatus == 'C' && !stampDetail?.stampFileId
                    })}>
                      {
                        docDetail?.statusProcessId == STATUS_PROCESS.Complete &&
                        <div className={classes.appValue1} style={{
                          display: "flex", justifyContent: "space-between", width: "100%"

                        }}>
                          <span>
                          หนังสืออนุมัติ*
                          </span>
                          <UploadButton
                            variant="contained"
                            color="warning"
                            id='editstampFileId'
                            size="small"
                            title={'แก้ไข'}
                            style={{ textDecoration: "underline", color: "rgb(16, 148, 216)", fontSize: "13px", fontWeight: "500", height: "auto", border: "none" }}
                            onChange={async (event) => {

                              const response = await FileService.uploadFile({
                                file: event.target.files[0],
                                FileID: null,
                                Status: true,
                              });

                              const fileId = response.results?.fileID;


                              const res = await AppointmentService.userStampUploadRequest({
                                draftId: stampDetail?.draftId,
                                stampFileId: fileId,
                                workPermitFileId: stampDetail?.workPermitFileId,
                                immigrationFileId: stampDetail?.immigrationFileId
                              });
                              if (res.status) {
                                await getAppointment();
                              }

                            }}>Edit</UploadButton>
                        </div>
                      }
                      <div className={classes.appValue2}>
                        {
                          stampDetail?.stampStatus == 'C' && !stampDetail?.stampFileId &&
                          <>
                            <UploadButton
                              size="small"
                              title={'อัปโหลด*'}
                              id='uploadstampFileId'
                              style={{ width: "150px", height: "auto", borderColor: "#ED1C24", color: "#ED1C24" }}
                              onChange={async (event) => {

                                const response = await FileService.uploadFile({
                                  file: event.target.files[0],
                                  FileID: null,
                                  Status: true,
                                });

                                const fileId = response.results?.fileID;


                                const res = await AppointmentService.userStampUploadRequest({
                                  draftId: stampDetail?.draftId,
                                  stampFileId: fileId,
                                  workPermitFileId: stampDetail?.workPermitFileId,
                                  immigrationFileId: stampDetail?.immigrationFileId
                                });
                                if (res.status) {
                                  await getAppointment();
                                }

                              }}
                            />
                            <div style={{ color: "rgb(95, 95, 95)", fontSize: "10px", marginTop: "5px" }}>
                              File Upload ( PDF, JPG )
                            </div>
                          </>
                        }

                        {
                          stampDetail?.stampStatus == 'C' && stampDetail?.stampFileId &&

                          <>
                            <div
                              style={{ cursor: 'pointer', display: 'flex' }}
                              onClick={() => {
                                openFileById(stampDetail?.stampFileId);
                              }}>
                              <div style={{ marginRight: 30 }}>
                                <img src={'/assets/pdf.svg'} />
                              </div>


                              <div style={{ color: "rgb(23, 43, 77)", fontWeight: "bold", fontSize: "15px", textDecoration: "underline" }}>
                                {stampDetail?.stampFileName} {stampDetail?.stampFileExt}
                              </div>

                            </div>

                          </>

                        }
                      </div>
                    </div>
                  </div>
                  {
                    stampDetail?.stampStatus == 'C' && !stampDetail?.stampFileId &&
                    <div className={classes.requiredDoc}>
                      <span>
                        กรุณาอัปโหลดเอกสาร
                      </span>

                    </div>
                  }
                </Grid>
                <Grid item xs={12} md={4} style={{ borderRight: "1px solid lightgray" }}>
                  <div className={classes.middle} >

                    <div style={{ position: 'relative', padding: 15 }} className={clsx({
                      [classes.nofile]: stampDetail?.stampStatus == 'C' && !stampDetail?.workPermitFileId
                    })}>
                      {
                        stampDetail?.stampStatus == 'C' &&
                        <div className={classes.appValue1} style={{
                          display: "flex", justifyContent: "space-between", width: "100%"

                        }}>
                          <span>
                            ใบอนุญาตทำงาน*
                          </span>
                          <UploadButton
                            variant="contained"
                            color="warning"
                            size="small"
                            title={'แก้ไข'}
                            id='editworkPermitFileId'
                            style={{ textDecoration: "underline", color: "rgb(16, 148, 216)", fontSize: "13px", fontWeight: "500", height: "auto", border: "none" }}
                            onChange={async (event) => {

                              console.log(event);
                              const response = await FileService.uploadFile({
                                file: event.target.files[0],
                                FileID: null,
                                Status: true,
                              });

                              const fileId = response.results?.fileID;


                              const res = await AppointmentService.userStampUploadRequest({
                                draftId: stampDetail?.draftId,
                                workPermitFileId: fileId,

                                stampFileId: stampDetail?.stampFileId,
                                immigrationFileId: stampDetail?.immigrationFileId

                              });
                              if (res.status) {
                                await getAppointment();
                              }

                            }}>Edit</UploadButton>
                        </div>
                      }
                      <div className={classes.appValue2}>
                        {
                          stampDetail?.stampStatus == 'C' && !stampDetail?.workPermitFileId &&
                          <>
                            <UploadButton
                              size="small"
                              title={'อัปโหลด*'}
                              id='uploadworkPermitFileId'
                              style={{ width: "150px", height: "auto", borderColor: "#ED1C24", color: "#ED1C24" }}
                              onChange={async (event) => {
                                console.log(event);
                                const response = await FileService.uploadFile({
                                  file: event.target.files[0],
                                  FileID: null,
                                  Status: true,
                                });

                                const fileId = response.results?.fileID;


                                const res = await AppointmentService.userStampUploadRequest({
                                  draftId: stampDetail?.draftId,
                                  workPermitFileId: fileId,
                                  stampFileId: stampDetail?.stampFileId,
                                  immigrationFileId: stampDetail?.immigrationFileId
                                });
                                if (res.status) {
                                  await getAppointment();
                                }

                              }}
                            />
                            <div style={{ color: "rgb(95, 95, 95)", fontSize: "10px", marginTop: "5px" }}>
                              File Upload ( PDF, JPG )
                            </div>
                          </>
                        }

                        {
                          stampDetail?.stampStatus == 'C' && stampDetail?.workPermitFileId &&

                          <>
                            <div
                              style={{ cursor: 'pointer', display: 'flex' }}
                              onClick={() => {
                                openFileById(stampDetail?.workPermitFileId);
                              }}>
                              <div style={{ marginRight: 30 }}>
                                <img src={'/assets/pdf.svg'} />
                              </div>


                              <div style={{ color: "rgb(23, 43, 77)", fontWeight: "bold", fontSize: "15px", textDecoration: "underline" }}>
                                {stampDetail?.workPermitFileName} {stampDetail?.workPermitFileExt}
                              </div>

                            </div>

                          </>

                        }
                      </div>
                    </div>
                  </div>

                  {
                    stampDetail?.stampStatus == 'C' && !stampDetail?.stampFileId &&
                    <div className={classes.requiredDoc}>
                      <span>
                        กรุณาอัปโหลดเอกสาร
                      </span>

                    </div>
                  }
                </Grid>

                <Grid item xs={12} md={4}>
                  <div className={classes.middle} >

                    <div style={{ position: 'relative', padding: 15 }} className={clsx({
                      [classes.nofile]: stampDetail?.stampStatus == 'C' && !stampDetail?.immigrationFileId
                    })}>
                      {
                        stampDetail?.stampStatus == 'C' &&
                        <div className={classes.appValue1} style={{
                          display: "flex", justifyContent: "space-between", width: "100%"

                        }}>
                          <span>
                            ตราขาเข้า*
                          </span>
                          <UploadButton
                            variant="contained"
                            color="warning"
                            size="small"
                            title={'แก้ไข'}
                            id='editimmigrationFileId'
                            style={{ textDecoration: "underline", color: "rgb(16, 148, 216)", fontSize: "13px", fontWeight: "500", height: "auto", border: "none" }}
                            onChange={async (event) => {

                              const response = await FileService.uploadFile({
                                file: event.target.files[0],
                                FileID: null,
                                Status: true,
                              });

                              const fileId = response.results?.fileID;


                              const res = await AppointmentService.userStampUploadRequest({
                                draftId: stampDetail?.draftId,
                                workPermitFileId: stampDetail?.workPermitFileId,
                                stampFileId: stampDetail?.stampFileId,
                                immigrationFileId: fileId



                              });
                              if (res.status) {
                                await getAppointment();
                              }

                            }}>Edit</UploadButton>
                        </div>
                      }
                      <div className={classes.appValue2}>
                        {
                          stampDetail?.stampStatus == 'C' && !stampDetail?.immigrationFileId &&
                          <>
                            <UploadButton
                              size="small"
                              title={'อัปโหลด*'}
                              id='uploadimmigrationFileId'
                              style={{ width: "150px", height: "auto", borderColor: "#ED1C24", color: "#ED1C24" }}
                              onChange={async (event) => {

                                const response = await FileService.uploadFile({
                                  file: event.target.files[0],
                                  FileID: null,
                                  Status: true,
                                });

                                const fileId = response.results?.fileID;


                                const res = await AppointmentService.userStampUploadRequest({
                                  draftId: stampDetail?.draftId,
                                  immigrationFileId: fileId,
                                  stampFileId: stampDetail?.stampFileId,
                                  workPermitFileId: stampDetail?.workPermitFileId
                                });
                                if (res.status) {
                                  await getAppointment();
                                }

                              }}
                            />
                            <div style={{ color: "rgb(95, 95, 95)", fontSize: "10px", marginTop: "5px" }}>
                              File Upload ( PDF, JPG )
                            </div>
                          </>
                        }

                        {
                          stampDetail?.stampStatus == 'C' && stampDetail?.immigrationFileId &&

                          <>
                            <div
                              style={{ cursor: 'pointer', display: 'flex' }}
                              onClick={() => {
                                openFileById(stampDetail?.immigrationFileId);
                              }}>
                              <div style={{ marginRight: 30 }}>
                                <img src={'/assets/pdf.svg'} />
                              </div>


                              <div style={{ color: "rgb(23, 43, 77)", fontWeight: "bold", fontSize: "15px", textDecoration: "underline" }}>
                                {stampDetail?.immigrationFileName} {stampDetail?.immigrationFileExt}
                              </div>

                            </div>

                          </>

                        }
                      </div>
                    </div>
                  </div>

                  {
                    stampDetail?.stampStatus == 'C' && !stampDetail?.stampFileId &&
                    <div className={classes.requiredDoc}>
                      <span>
                        กรุณาอัปโหลดเอกสาร
                      </span>

                    </div>
                  }
                </Grid>

                {/*                 
                <Grid item xs={12} md={4} className={classes.middle}>
                  {
                    stampDetail?.stampStatus == 'C' &&

                    <ColorButton variant="outlined" size="small" color="warning"
                      style={{ height: "100px", backgroundColor: "white", color: "#1094D8", border: "1px solid #1094D8" }}
                      onClick={() => {
                        setOpen(true);
                      }}>


                      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }} onClick={() => {
                        setOpen(true);
                      }}>
                        <BlockIcon />
                        <span style={{ marginTop: 10 }}>
                          ยกเลิกสิทธิ์ผู้แทน
                        </span>

                      </div>

                    </ColorButton>
                  }

                </Grid> */}
              </Grid>
            </div>

            <div className={classes.wrapDocDetail} style={{ paddingBottom: "40px", textAlign: 'center' }}>

              {

                stampDetail?.stampStatus == 'C' &&
                // <ColorButton variant="outlined" size="small" color="warning"
                //   style={{ backgroundColor: "white", color: "#1094D8", border: "1px solid #1094D8" }}
                //   onClick={() => {
                //     setOpen(true);
                //   }}>


                // <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }} onClick={() => {
                //   setOpen(true);
                // }}>
                //   <BlockIcon />
                //   <span style={{ marginTop: 10 }}>
                //     ยกเลิกสิทธิ์ผู้แทน
                //   </span>

                // </div>

                <>
                  <div className={classes.appointmentDate2} style={{ marginRight: 15, cursor: 'pointer', backgroundColor: '#ed1c24' }}
                    onClick={async () => {
                      setOpen(true);
                    }}
                  >
                    <div className={classes.wrapAppointmentDate}>
                      <BlockIcon style={{ marginRight: 10 }} />
                      <span>
                        ยกเลิกสิทธิ์ผู้แทน
                      </span>
                    </div>
                  </div>

                </>
                // </ColorButton>
              }
              {
                stampDetail?.stampStatus == 'C' &&
                stampDetail?.stampFileId &&
                stampDetail?.workPermitFileId &&
                stampDetail?.immigrationFileId &&
                <div className={classes.appointmentDate2} style={{ marginRight: 15, cursor: 'pointer' }}
                  onClick={async () => {
                    const body = {
                      draftId: stampDetail?.draftId
                    };
                    const blob = await AppointmentService.getReportBenefits(body)

                    const blobFile = new File([blob], 'benefits.pdf', {
                      type: mime.getType('.pdf'),
                    });

                    window.open(
                      URL.createObjectURL(blobFile, 'benefits.pdf'),
                      "_blank"
                    );
                  }}
                >
                  <div className={classes.wrapAppointmentDate}>
                    <PrintIcon style={{ marginRight: 10 }} />
                    <span>
                      พิมพ์ใบอนุมัติ
                    </span>
                  </div>


                </div>
              }

              {
                true &&

                <div className={classes.appointmentDate2} style={{ marginRight: 15, cursor: 'pointer' }}
                  onClick={async () => {
                    const body = {
                      draftId: stampDetail?.draftId
                    };
                    const blob = await AppointmentService.getReportSeal(body)

                    const blobFile = new File([blob], 'seal.pdf', {
                      type: mime.getType('.pdf'),
                    });

                    window.open(
                      URL.createObjectURL(blobFile, 'seal.pdf'),
                      "_blank"
                    );
                  }}
                >
                  <div className={classes.wrapAppointmentDate}>
                    <PrintIcon style={{ marginRight: 10 }} />
                    <span>
                      พิมพ์ใบประทับตรา
                    </span>
                  </div>


                </div>
              }
            </div>
          </TabPanel>


        }
      </div >
    </Paper >
  );
}
export default withLayout(AppointmentTab);



function ChangeUserPass(props) {

  const defaultInputs = {
    username: "",
    password: "",
  };
  const classes = useStyles();
  const { onClose, open } = props;
  const [input, setInput] = useState(defaultInputs);


  const handleClose = () => {
    onClose();
  };

  const handleSave = async () => {
    onClose({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInput({
      ...input,
      [name]: value,
    });
  };


  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="xs"
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title" >
        <div style={{ color: '#40B8D4', fontSize: 26, textAlign: 'center' }}>
          ยกเลิกสิทธิ์ผู้แทน
        </div>
      </DialogTitle>
      <DialogContent>
        {/* <div >
          
        </div> */}
        <div>
          <label>
            หากท่านต้องการยกเลิกสิทธิ์ผู้แทนสามารถดำเนินการผ่านลิงก์ด้านล่าง
          </label>
          <a href="https://testoneid.inet.co.th/" style={{ color: '#40B8D4', fontSize: 18, textAlign: 'center', display: 'block' }}>
            https://testoneid.inet.co.th/
          </a>
        </div>
        <div>

        </div>

        <div className={classes.warpButtonDialogSave} style={{ marginTop: 15 }}>

          <Button

            variant="outlined"
            size="medium"
            color="primary"
            onClick={() => handleClose()}
            className={classes.buttonDialogSave}
          >
            Cancel
          </Button>

        </div>
      </DialogContent>
    </Dialog>
  );
}



function DocumentUpload(props) {


  const classes = useStyles();
  const { onClose, open } = props;



  const handleClose = () => {
    onClose();
  };


  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      fullWidth={true}
      maxWidth="xs"
      className={classes.warpDialog}
    >
      <DialogTitle id="simple-dialog-title" >
        <div style={{ color: '#40B8D4', fontSize: 26, textAlign: 'center' }}>
          กรุณาอัปโหลดเอกสาร
        </div>
      </DialogTitle>
      <DialogContent>

        <div>
          <label style={{ color: 'rgba(237, 28, 36, 0.8)' }}>
            กรุณาอัปโหลดเอกสารใบประทับตราและใบขาเข้า
            เพื่อรับใบอนุมัติ
          </label>

        </div>
        <div>

        </div>

        <div className={classes.warpButtonDialogSave} style={{ marginTop: 15 }}>

          <Button

            variant="outlined"
            size="medium"
            color="primary"
            onClick={() => handleClose()}
            className={classes.buttonDialogSave}
          >
            OK
          </Button>

        </div>
      </DialogContent>
    </Dialog>
  );
}
